<script>
  import axios from 'axios'
  import { chargeBeeEditBilling, chargeBeeEditPayment } from '../../chargebee'

  export default {
    name: 'CAccount',
    props: {
      returnTo: {
        type: String,
        default: () => `${window.location.origin}/`,
      },
    },
    data () {
      return {
        loading: {
          reset: false,
          billing: false,
          payment: false,
          mfa: false,
        },
      }
    },
    methods: {
      async resetPassword () {
        try {
          this.loading.reset = true
          await axios.post('/customer/reset_password')
          this.$toast.success(
            `We sent you an email to ${this.$auth0.normalizedUser.email} so you can reset your password.`,
          )
        } catch (e) {
          this.$toast.error(e)
        } finally {
          this.loading.reset = false
        }
      },
      async changeMfa (val) {
        try {
          this.loading.mfa = true
          await axios.put('/customer/mfa', { mfa_flag: val })
          if (val) {
            // val === true will cause a logout because auth0 requires a new authentication
            await this.$auth0.logout()
          }
          this.$toast.success(`Multi-factor authentication is now ${val ? 'enabled' : 'disabled'}.`)
        } catch (e) {
          this.$toast.error(e)
        } finally {
          this.loading.mfa = false
        }
      },
      async editBilling () {
        try {
          this.loading.billing = true
          await chargeBeeEditBilling()
        } catch (e) {
          this.$toast.error('Sorry, we could not get your billing information.')
        } finally {
          this.loading.billing = false
        }
      },
      async editPayment () {
        try {
          this.loading.payment = true
          await chargeBeeEditPayment()
        } catch (e) {
          this.$toast.error('Sorry, we could not get your payment information.')
        } finally {
          this.loading.payment = false
        }
      },
    },
    render () {
      const {
        isAuthenticated,
        logout,
        error,
        normalizedUser,
      } = this.$auth0

      return this.$scopedSlots.default({
        loading: this.loading,
        user: normalizedUser,
        error,
        isAuthenticated,
        editPayment: this.editPayment,
        editBilling: this.editBilling,
        resetPassword: this.resetPassword,
        changeMfa: this.changeMfa,
        logout: () => logout({ logoutParams: { returnTo: this.returnTo } }),
      })
    },
  }
</script>
